// pvmCodes.js
const pvmCodes = [
  { value: "PVM1", label: "PVM1 - 21%" },
  { value: "PVM2", label: "PVM2 - 9%" },
  { value: "PVM3", label: "PVM3 - 5%" },
  { value: "PVM25", label: "PVM25 - 21%" },
  { value: "PVM26", label: "PVM26 - 9%" },
  { value: "PVM27", label: "PVM27 - 5%" },
  { value: "PVM5", label: "PVM5 - 0%" },
  { value: "PVM6", label: "PVM6 - 21%" },
  { value: "PVM7", label: "PVM7 - 9%" },
  { value: "PVM8", label: "PVM8 - 5%" },
  { value: "PVM28", label: "PVM28 - 0%" },
  { value: "PVM29", label: "PVM29 - 0%" },
  { value: "PVM9", label: "PVM9 - 21%" },
  { value: "PVM30", label: "PVM30 - 9%" },
  { value: "PVM31", label: "PVM31 - 5%" },
  { value: "PVM32", label: "PVM32 - 21%" },
  { value: "PVM33", label: "PVM33 - 0%" },
  { value: "PVM12", label: "PVM12 - 0%" },
  { value: "PVM13", label: "PVM13 - 0%" },
  { value: "PVM14", label: "PVM14 - 0%" },
  { value: "PVM15", label: "PVM15 - 0%" },
  { value: "PVM34", label: "PVM34 - 0%" },
  { value: "PVM16", label: "PVM16 - 21%" },
  { value: "PVM17", label: "PVM17 - 9%" },
  { value: "PVM18", label: "PVM18 - 5%" },
  { value: "PVM35", label: "PVM35 - 0%" },
  { value: "PVM36", label: "PVM36 - 0%" },
  { value: "PVM19", label: "PVM19 - 0%" },
  { value: "PVM20", label: "PVM20 - 21%" },
  { value: "PVM37", label: "PVM37 - 5%" },
  { value: "PVM38", label: "PVM38 - 0%" },
  { value: "PVM39", label: "PVM39 - 0%" },
  { value: "PVM21", label: "PVM21 - 21%" },
  { value: "PVM40", label: "PVM40 - 5%" },
  { value: "PVM41", label: "PVM41 - 0%" },
  { value: "PVM42", label: "PVM42 - 0%" },
  { value: "PVM43", label: "PVM43 - 21%" },
  { value: "PVM44", label: "PVM44 - 9%" },
  { value: "PVM45", label: "PVM45 - 5%" },
  { value: "PVM46", label: "PVM46 - 0%" },
  { value: "PVM47", label: "PVM47 - 0%" },
  { value: "PVM23", label: "PVM23 - 0%" },
  { value: "PVM24", label: "PVM24 - 0%" },
  { value: "PVM48", label: "PVM48 - 0%" },
  { value: "PVM49", label: "PVM49 - 6%" },
  { value: "PVM100", label: "PVM100 - Kiti atvejai" },
  { value: "PVM50", label: "PVM50 - 0%" },
  { value: "PVM51", label: "PVM51 - 0%" },
  { value: "PVM52", label: "PVM52 - 9%" },
  { value: "PVM53", label: "PVM53 - 5%" },
  { value: "PVM54", label: "PVM54 - 9%" },
  { value: "PVM55", label: "PVM55 - 0%" },
  { value: "PVM56", label: "PVM56 - 0%" },
  { value: "PVM57", label: "PVM57 - 9%" },
  { value: "NE_ISAF", label: "NE_ISAF - Nepatenka į I.SAF ataskaitą" },
];

export default pvmCodes;
